import { render, staticRenderFns } from "./nuevoPedido.vue?vue&type=template&id=6b528a8b&scoped=true"
import script from "./nuevoPedido.vue?vue&type=script&lang=js"
export * from "./nuevoPedido.vue?vue&type=script&lang=js"
import style0 from "./nuevoPedido.vue?vue&type=style&index=0&id=6b528a8b&prod&scoped=true&lang=css"
import style1 from "./nuevoPedido.vue?vue&type=style&index=1&id=6b528a8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b528a8b",
  null
  
)

export default component.exports